<template>
  <v-layout row >
    <v-flex md12>
      <v-card>
        <!-- <div class="ibox float-e-margins"> -->
          <v-toolbar dense primary-title>
            <v-toolbar-title>
                {{$t('view.usuario.registros.label')}}
             </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="view.elem.showTable = !view.elem.showTable">
              <v-icon>{{ view.elem.showTable ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
          </v-toolbar>
          <v-slide-y-transition>
            <v-card-text v-show="view.elem.showTable">
              <v-layout row>
                <v-flex md12>
                  <div class="table-responsive">
                    <table id="something" class="table table-striped table-bordered table-hover responsive nowrap dataTables-example "  style="width:100%">
                      <thead>
                        <tr>
                          <th class="all col-md-2">Fecha y hora</th>
                          <th class="all col-md-2">Módulo</th>
                          <th class="none">URL</th>
                          <th class="all col-md-2">IP de Solicitud</th>
                          <th class="all col-md-2">Usuario</th>
                          <th class="none col-md-1 col-sm-1 col-xs-2" style="width: 100px !important; max-width: 100px !important;">Acción</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-slide-y-transition>
        <!-- </div> -->
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
//import BitacoraAPI from "@/services/bitacora";

export default {
  data() {
    return {
      count:0
      , dataTable:undefined
      , view:{
        elem:{
          showTable: true
        }
      }
    }
  }
  , props:{
    pageLength:{
      default:10
      , type:Number
    }
    , responsive:{
      default:true
      , type:Boolean
    }
    , dom:{
      default:'<"html5buttons"B>lTfgitp'
    } 
  }
  ,methods: {
    refreshData(){
      this.dataTable._fnReDraw();
      // this.dataTable._fnAjaxUpdate();
    }
  }
  , computed:{}
  , components: {}
  // Instance Lifecycle Hooks
  , created(){
    //window.$('.dataTables-example').DataTable({});  
  }
  , mounted(){
    const vm = this;
        function formatDate( date, params ) {
      if(date != null)
      {
        var options = {
            year: "numeric"
            , month: "2-digit"
            , day: "2-digit"
            , hour:"2-digit"
            , minute:"2-digit"
            , second:"2-digit"
        };

        if( params ) {
            options = Object.assign( options, params );
        }
        return new Date( date ).toLocaleString( 'es-MX', options );
      }
      else 
      {
        return '';
      }
    };
    this.$nextTick(function(){
      vm.dataTable=window.$('#something').dataTable({     
        "bProcessing": true
        , "bServerSide": true
        , "bPaginate":true
        , "pageLength" : vm.pageLength
        , "language": { "url": '/static/js/dataTables/language/dataTables.spanish.json' }
        , "responsive": true  
        , "ajax":{
          "url": "/api/bitacora"
          , "type": "POST"
          , "async":true
          ,"headers":{
            "Authorization":`Bearer ${vm.$store.getters.getUserToken}`
          }
          , "data"    : function(data){
            let {fecha_fin,fecha_inicio,usuario_username} = vm.$parent.bitacora;

            let objFilter = {};

            if(usuario_username != null && usuario_username.length > 0){
              let usuario_usernameValue = usuario_username.map(({code}) => code).toString();
              objFilter['usuario_username'] = usuario_usernameValue;
            }
            if(fecha_inicio != null && fecha_inicio != '' && typeof fecha_inicio != undefined
              && fecha_fin != null && fecha_fin != '' && typeof fecha_fin != undefined){
                objFilter['fecha'] = '('+fecha_inicio+'|'+fecha_fin+')';
            }
          
            if(typeof objFilter.fecha != undefined || typeof objFilter.usuario_username != undefined ){
              data.filtros = JSON.stringify(objFilter);
            }
           
          }
          , "complete": function(response){
            //console.log(response)
          }
          , "error"   : function(error){
            console.log(error)
          }
        }
        , "aaSorting" : [[0, 'desc']]
        , "aoColumns": [
          {
            "data":"fecha"
            , "sClass":"text-center"
          },
          {
            "data":"modulo"
            , "sClass":"text-center"
          },
          {
            "data":"url"
            , "sClass":"text-center none"
          },
          {
            "data":"requestAddress"
            , "sClass":"text-center"
          },
          {
            "data":"usuario_username"
            , "sClass":"text-center"
          },
          {
            "data":"accion"
            , "sClass":""
          },
        ]
        , "aoColumnDefs":[
          {
            "aTargets": [ 0 ],
            "mData": "fecha",
            "mRender": function ( data, type, full ) {
              return formatDate(data);
            }
          }
         , {
            "aTargets": [ 5 ],
            "mData": "accion",
            "mRender": function ( data, type, full ) {
              return data;
            }
          }
        ]
      });
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bitacoras/bitacora/DataTable.vue